<template>
  <div>
    <div v-if="isLoading" class="d-block preloader-block">
      <preloader />
    </div>
    <div v-else>
      <div class="second-sidebar__title">
        <h4 v-if="category">{{ category.title }}</h4>
      </div>
      <div class="main__category_children__wrap">
        <category-child v-for="cat in cats" :key="cat.id" :category="cat" />
      </div>
    </div>
  </div>
</template>
<script>
import Preloader from "./Preloader";
import CategoryChild from "./templates/CategoryChild";

export default {
  components: { CategoryChild, Preloader },
  beforeRouteUpdate(to, from, next) {
    this.fetchCategories(to.params.id);
    next();
  },
  data() {
    return {
      cats: [],
      isLoading: true,
    };
  },
  computed: {
    category() {
      return CATEGORY_LIST.find((i) => {
        return i.id === parseInt(this.$route.params.id);
      });
    },
  },
  created() {
    if (window.screen.width <= 768) {
      this.$store.commit("setCategoriesView", false);
    }
    this.fetchCategories(this.$route.params.id);
  },
  mounted() {
    this.$store.commit("setChildrenView", true);
  },
  methods: {
    fetchCategories(category_id) {
      let sidebar = this.$store.getters.getRef("sidebar");
      sidebar.classList.remove("home-shown");

      this.isLoading = true;
      let location = JSON.stringify(this.$store.getters.getLocation);
      this.$http
        .get(`category/${category_id}/children/location/${location}`)
        .then((res) => {
          this.cats = res.data;
          this.isLoading = false;

          if (this.category) {
            this.$store.commit("setMetaTitle", this.category.title);
            this.$store.commit(
              "setH1",
              this.category.meta_h1
                ? this.category.meta_h1
                : this.category.title
            );
            this.$store.commit("triggerDynamicH1Resize");
          }
        });
    },
  },
};
</script>
